import type { FC } from 'react'
import type { ICmsInternalLinks } from '@/pages/tad.ai/_components/FeatureCms/_types'

import Link from '@/components/Link'
import { H2 } from '@/pages/tad.ai/_components/H2'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export interface IInternalLinksProps {
  data?: ICmsInternalLinks | null
  className?: string
}

export const InternalLinks: FC<IInternalLinksProps> = (props) => {
  const { data, className } = props
  if (!data) {
    return null
  }
  const { title, list } = data

  return (
    <div className={cls`${className}`}>
      <H2 className='text-f-text [&_a]:!text-f-primary mx-auto max-w-[750px] text-center text-6xl font-bold [&>a:hover]:underline'>
        {title}
      </H2>
      <ul className='mt-3 flex flex-col flex-nowrap justify-center gap-3 lg:flex-row '>
        {list.map((item) => (
          <Link href={item.link} key={item.label}>
            <li
              key={item.label}
              className='border-f-border hover:border-f-primary relative max-w-full rounded-xl border p-8 text-center md:max-w-full md:p-6 lg:max-w-[285px]'
            >
              <span className='text-xl text-white'>{item.label}</span>
              <RichTextElement
                as='p'
                html={item.text}
                className='text-f-other-10 pt-2 text-sm'
              />
            </li>
          </Link>
        ))}
      </ul>
    </div>
  )
}
